import { useQuery } from '@tanstack/react-query'

import { identityServices } from '../identityServices'

import { QUERY_KEYS } from '@/constants/queryKeys'

/**
 * GET /v1/identity/kyc/sdk/access-token
 * Gets KYC SDK access token
 */
export const useGetKycAccessToken = () =>
  useQuery({
    queryKey: [QUERY_KEYS.IDENTITY_KYC_SDK_ACCESS_TOKEN],
    queryFn: identityServices.getKycSdkAccessToken,
    staleTime: 15 * 60 * 1000, // 15 minutes
  })
